export const itemsHomeCaldera = [
  { index: "01", text: "Desarrollo de Ingeniería" },
  { index: "02", text: "Venta de calderas y equipos auxiliares" },
  { index: "03", text: "Instalación electromecánica" },
  { index: "04", text: "Puesta en Marcha" },
];
